import PropTypes from "prop-types"
import React from "react"

const PrintContactValue = ({ phone, email }) => {
  if (!phone && !email) return null

  return (
    <>
      {phone && <div>{phone}</div>}
      {email && <div>{email}</div>}
    </>
  )
}

PrintContactValue.propTypes = {
  phone: PropTypes.string,
  email: PropTypes.string,
}

export default PrintContactValue
